import * as bootstrap from 'bootstrap';
import api from './ajax.js';

document.addEventListener('DOMContentLoaded', () => {
	const messageModal = document.getElementById('messageModal');
	const textArea = document.getElementById('textMessageBody');

	if (!messageModal) {
		return;
	}

	// Listen for Bootstrap's modal shown event
	messageModal.addEventListener('shown.bs.modal', (event) => {
		const trigger = event.relatedTarget; // the element that triggered the modal
		const jobId = trigger.dataset.spJob;
		const jobName = trigger.dataset.spJobName;

		// Get the modal title element
		const titleEl = messageModal.querySelector('.modal__title');

		// Remove an existing paragraph if it exists to prevent duplicates
		const nextEl = titleEl.nextElementSibling;
		if (nextEl && nextEl.tagName.toLowerCase() === 'p') {
			nextEl.remove();
		}

		// Create a new paragraph element
		const messagePara = document.createElement('p');
		messagePara.textContent = `Send a message to the team working on ${jobName}`;

		// Add a class to the paragraph
		messagePara.classList.add('text-center');

		// Add style to the paragraph
		messagePara.style.marginLeft = 'auto';
		messagePara.style.marginRight = 'auto';
		messagePara.style.maxWidth = '380px';

		// Insert the paragraph right after the title
		titleEl.insertAdjacentElement('afterend', messagePara);

		// Save the jobId on the modal element for later use
		messageModal.dataset.jobId = jobId;

		// Remove any previous alert message when reopening the modal
		const existingAlert = messageModal.querySelector('.alert');
		if (existingAlert) existingAlert.remove();
	});

	// Clear the textarea on modal close
	messageModal.addEventListener('hidden.bs.modal', () => {
		textArea.value = '';
	});

	// Helper function to show alert in modal
	const showAlert = (type, message, failures = []) => {
		const modalBody = messageModal.querySelector('.modal__body');

		// Remove any existing alerts
		const existingAlerts = messageModal.querySelectorAll('.alert');
		existingAlerts.forEach(alert => alert.remove());

		const alertDiv = document.createElement('div');
		alertDiv.className = `alert alert-${type}`;

		let alertContent = `<strong>${message}</strong>`;

		if (failures.length > 0) {
			alertContent += '<ul class="mb-0 mt-2">';
			failures.forEach(failure => {
				alertContent += `<li>${failure.staff_name}: ${failure.reason}</li>`;
			});
			alertContent += '</ul>';
		}

		alertDiv.innerHTML = alertContent;
		modalBody.insertBefore(alertDiv, modalBody.firstChild);
	};

	// Bind a click event to the Send button
	const sendMessageButton = document.getElementById('sendMessage');
	sendMessageButton.addEventListener('click', () => {
		// Show the spinner icon
		const spinner = sendMessageButton.querySelector('svg');
		if (spinner) spinner.style.display = 'inline-block';

		// Remove any existing alert message
		const existingAlert = messageModal.querySelector('.alert');
		if (existingAlert) existingAlert.remove();

		const jobId = messageModal.dataset.jobId;
		const messageEl = document.getElementById('textMessageBodyJob');
		const message = messageEl.value;

		if (!jobId) {
			if (spinner) spinner.style.display = 'none';
			return;
		}

		api.sendMessage(jobId, message)
			.then(response => {
				if (response.error) {
					// AJAX error occurred
					showAlert('danger', 'An error occurred while trying to send message');
					return;
				}

				const data = response.body;

				if (data.status === 'success') {
					// All messages sent successfully - close modal
					const modalInstance = bootstrap.Modal.getInstance(messageModal);
					if (modalInstance) modalInstance.hide();
				} else if (data.status === 'partial') {
					// Some messages sent, some failed - show warning with details
					showAlert('warning', data.message, data.failures || []);
				} else if (data.status === 'failed') {
					// All messages failed - show error with details
					showAlert('danger', data.message, data.failures || []);
				} else if (data.status === 'warning') {
					// No staff to send to
					showAlert('warning', data.message);
				}
			})
			.catch(() => {
				showAlert('danger', 'An error occurred while trying to send message');
			})
			.finally(() => {
				if (spinner) spinner.style.display = 'none';
			});
	});
});
